module.exports = __webpack_public_path__ + "img/user30.8c1504e3.jpg";